export const defaultSurveyRangeTooltip = [
  "zdecydowanie poniżej oczekiwań",
  "poniżej oczekiwań",
  "zgodnie z oczekiwaniami",
  "powyżej oczekiwań",
  "zdecydowanie powyżej oczekiwań",
];
